var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.src)?_c('svg-injector',{attrs:{"class-name":_vm.classes,"src":_vm.src}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }